import { Copies } from "shared/hooks/useCopies";
import PurchaseOrderLineAdjustmentType from "shared/model/PurchaseOrderLineAdjustmentType";

export function getQuantityToDisplay(quantity: number, type: PurchaseOrderLineAdjustmentType, copies: Copies) {
  if (!quantity) {
    return;
  }
  switch (type) {
    case PurchaseOrderLineAdjustmentType.ADD:
      return `+ ${quantity}`;
    case PurchaseOrderLineAdjustmentType.PARTIAL_REMOVE:
      return `- ${quantity}`;
    case PurchaseOrderLineAdjustmentType.CANCEL:
      return copies.get("cancel");
    default:
      return "";
  }
}
